import ICON_SIZE, { ICON_COLOR } from '@/constant/icon-size-color';

export default function PiHeart({
  color = ICON_COLOR.gray,
  size = ICON_SIZE.lg,
}: {
  color?: string;
  size?: number;
}) {
  return (
    <svg
      stroke={color}
      fill={color}
      strokeWidth='0'
      viewBox='0 0 256 256'
      height={size}
      width={size}
      xmlns='http://www.w3.org/2000/svg'
    >
      <path d='M178,40c-20.65,0-38.73,8.88-50,23.89C116.73,48.88,98.65,40,78,40a62.07,62.07,0,0,0-62,62c0,70,103.79,126.66,108.21,129a8,8,0,0,0,7.58,0C136.21,228.66,240,172,240,102A62.07,62.07,0,0,0,178,40ZM128,214.8C109.74,204.16,32,155.69,32,102A46.06,46.06,0,0,1,78,56c19.45,0,35.78,10.36,42.6,27a8,8,0,0,0,14.8,0c6.82-16.67,23.15-27,42.6-27a46.06,46.06,0,0,1,46,46C224,155.61,146.24,204.15,128,214.8Z'></path>
    </svg>
  );
}
